export default __webpack_public_path__ + "static/media/found-white.f75ea27e.svg";